import {Component, OnInit} from '@angular/core';
import * as fromRoot from '../app.reducer';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-start-page',
  template: `<div>
  <h1></h1>
  <p>
    Welcome to the United States Department of Agriculture (USDA) Agricultural Research Service (ARS) Environmental Information Repository Website.  Please click on one of the following projects to proceed.
  </p>
  <p>
    <a routerLink="/barc">Beltsville Agricultural Research Service (BARC)</a>
  </p>
  <p>
    <a routerLink="/glenndale">Former Glenn Dale Plant Introduction Station</a>
  </p>
  </div>
`
})
export class StartPageComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/containers/start-page.ts